import { render, staticRenderFns } from "./StyledListBlock.vue?vue&type=template&id=e3aa4830&"
import script from "./StyledListBlock.vue?vue&type=script&lang=js&"
export * from "./StyledListBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports